export const copyToClipboardFrom = (fromControl: HTMLInputElement | HTMLTextAreaElement) => {
  fromControl.select();
  document.execCommand('copy');
};

export const copyTextToClipboard = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'absolute';
  textarea.style.overflow = 'hidden';
  textarea.style.width = '1px';
  textarea.style.height = '1px';
  textarea.style.border = 'none';
  textarea.style.margin = 'none';
  textarea.style.top = '-10px';
  textarea.style.left = '-10px';
  document.body.appendChild(textarea);
  copyToClipboardFrom(textarea);
  document.body.removeChild(textarea);
};

export const copyToClipboard = (target: string | HTMLInputElement | HTMLTextAreaElement) => {
  console.log('copyToClipboard', target);
  if (typeof target === 'string') {
    copyTextToClipboard(target);
  } else {
    copyToClipboardFrom(target);
  }
};
